import { Paper, Stack, useTheme } from '@mui/material';
import OrganizationProfessionalCalendarContent from 'src/sections/@dashboard/organization/components/OrganizationProfessionals/OrganizationProfessional/OrganizationProfessionalCalendarContent';

export default function OrganizationProfessionalTabsCalendarPage() {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        borderRadius: 2,
        boxShadow: theme.customShadows.z8,
        height: 1,
      }}
    >
      <Stack sx={{ height: 1, minHeight: '560px', position: 'relative' }}>
        <OrganizationProfessionalCalendarContent />
      </Stack>
    </Paper>
  );
}
